import { render, staticRenderFns } from "./ActivityFrontPage.vue?vue&type=template&id=26f7ca27"
import script from "./ActivityFrontPage.vue?vue&type=script&lang=js"
export * from "./ActivityFrontPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports